import { CaseReducer, createSlice, PayloadAction } from '@reduxjs/toolkit';

export type UIState = {
  currentModalName: string;
  currentModalParams: null | object;
  hasModal: boolean;
  breakpoint: number;
  isOnLine: boolean;
  isWebpSupport: boolean;
};

const initialState: UIState = {
  currentModalName: '',
  currentModalParams: null,
  hasModal: false,
  breakpoint: 0,
  isOnLine: true,
  isWebpSupport: false,
};

type UIReducers = {
  hideModalAction: CaseReducer<UIState>;
  showModalAction: CaseReducer<
    UIState,
    PayloadAction<{ modalName: string; params?: Record<string, any> }>
  >;
  breakpointChangedAction: CaseReducer<UIState, PayloadAction<number>>;
  isOnlineCheckedAction: CaseReducer<UIState, PayloadAction<boolean>>;
  changeWebpSupportAction: CaseReducer<UIState, PayloadAction<boolean>>;
};
type UISelectors = {
  uiSelector: (state: UIState) => UIState;
  isWebpSupportSelector: (state: UIState) => boolean;
};

export const ui = createSlice<UIState, UIReducers, 'ui', UISelectors>({
  name: 'ui',
  initialState,
  reducers: {
    hideModalAction: (state) => ({
      ...state,
      currentModalName: '',
      currentModalParams: null,
      hasModal: false,
    }),
    showModalAction: (state, { payload: { params, modalName } }) => {
      const currentModalName = modalName;

      return {
        ...state,
        currentModalName,
        currentModalParams: params || null,
        hasModal: Boolean(currentModalName),
      };
    },
    breakpointChangedAction: (state, { payload }) => ({
      ...state,
      breakpoint: payload,
    }),
    isOnlineCheckedAction: (state, { payload }) => ({
      ...state,
      isOnLine: payload,
    }),
    changeWebpSupportAction: (state, { payload }) => ({
      ...state,
      isWebpSupport: payload,
    }),
  },
  selectors: {
    uiSelector: (ui) => ui,
    isWebpSupportSelector: (ui) => ui.isWebpSupport,
  },
});

export const {
  hideModalAction,
  showModalAction,
  isOnlineCheckedAction,
  breakpointChangedAction,
  changeWebpSupportAction,
} = ui.actions;

export const { uiSelector, isWebpSupportSelector } = ui.selectors;

export default ui.reducer;
